export default "__VITE_ASSET__CGLIR5T5__"